import { Route, Switch } from "react-router-dom";
import TeacherPages from "../../constants/TeacherPages";
import Loading from "../Loading"


function TeacherMain() {
    if (false) return <Loading />;

    let pages = new TeacherPages();
    let siteNamesByRoute: JSX.Element[] = pages.pages.map(page => <Route key={page.name} path={page.path}>{page.name}</Route>);
    let siteContentsByRoute: JSX.Element[] = pages.pages.map(page => <Route key={page.name} path={page.path}>{page.content}</Route>);

    return (
        <div className="py-10 flex-grow flex flex-col">
            <header>
                <div className="max-w-screen mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="text-3xl font-bold leading-tight text-gray-900">
                        <Switch>
                            {siteNamesByRoute}
                        </Switch>
                    </h1>
                </div>
            </header>
            <main className="flex-grow flex">
                <div className="px-4 py-8 sm:px-0 max-w-screen mx-auto lg:px-8 flex flex-grow">
                    <Switch>
                        {siteContentsByRoute}
                    </Switch>
                </div>
            </main>
        </div>
    );
}

export default TeacherMain;